define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/xml",
	"Sourcing"
], function(declare,_,xml,Sourcing) {

	return declare(null, {
		validParentStructureItemTypes: ["Category1", "Category2", "Collection", "MaterialSecurityGroup", "MaterialPlanPlacement", "MaterialPlanPlacementColorway", "Season", "Style"],

		products: null,

		toWriterRequest: function() {
			let call = this.inherited(arguments);

			// summary: create SupplierItems according to form
			const fd = this.m_formData;

			this.products = fd.getFieldValue(this.productField, true);

			const subtype = fd.getFieldValue("Subtype", true);
			let sources = this.getSourceUrlsBySubtype(subtype, fd);
			call = this.addParameterstoSRCall(call, fd, subtype, sources, []);

			return call;
		},

		/** @override */
		toWriter: function() {
			const fd = this.m_formData;
			this.products = fd.getFieldValue(this.productField, true);
		
			this.inherited(arguments);
			this.toWriterSRProducts();
		},

		/**
		 * Create the Call to add Products to SR
		 */
		toWriterSRProducts: function() {
			for (const p of this.products) {
				const call = this.m_writer.callMethod("Sourcing", "SupplierRequestAddProduct");
				call.addParameter("ParentURL", xml.ATTR_REF, this.m_urlNode)
				call.addParameter("FromURL",   xml.ATTR_REF, p);
			}
		},

		/**
		 * Returns the source urls (factories or suppliers) for the given subtype
		 * @param {C8Node} subtype 
		 * @param {FormData} fd - SR form data
		 * @returns sources - array of source urls
		 */
		getSourceUrlsBySubtype(subtype, fd) {
			let sources;
			if(!subtype || Sourcing.isSubtypeSupplierSourced(subtype)) {
				sources = fd.getFieldValue("SRSuppliers", true);
			} else {
				sources = fd.getFieldValue("SRSupplierFactories", true);
			}
			if(!Array.isArray(sources)) {
				sources = xml.isValidURL(sources) ? [sources] : [];
			}
			return sources;
		},

		/**
		 * Add Parameters to Create SR Call
		 * @param {Call} call - SR call
		 * @param {FormData} fd - SR form data
		 * @param {CNL} subtype - SR subtype
		 * @param {Array/CNL} sources - SR sources
		 * @returns {Call} call - SR call with added parameters
		 */
		addParameterstoSRCall: function(call, fd, subtype, sources, products) {
			call.addParameter("Name",                    xml.ATTR_STRING,  fd.getFieldValue("Node Name", true))
				.addParameter("RequestType",             xml.ATTR_ENUM,    fd.getFieldValue("RequestType", true))
				.addParameter("Products",                xml.ATTR_REFLIST, products)
				.addParameter("Subtype",                 xml.ATTR_REF, 	   subtype)
				.addParameter("Sources",                 xml.ATTR_REFLIST, Array.isArray(sources)? sources : [sources])
				.addParameter("SupplierRequestTemplate", xml.ATTR_REF,     fd.getFieldValue("SRTemplate", true))
				.addParameter("DataPackageTemplate",     xml.ATTR_REF,     fd.getFieldValue("SRDPTemplate", true))
				.addParameter("Requester",               xml.ATTR_REF,     fd.getFieldValue("Requester", true))
				.addParameter("DueDate",                 xml.ATTR_TIME,    fd.getFieldValue("DueDate", true));

			// populate parent structure item if necessary
			const parentStructureItem = this.getParentStructureItem();
			if (parentStructureItem) {
				call.addParameter("ParentStructureItem", xml.ATTR_REF, parentStructureItem);
			}
			return call;
		},
		
		/**
		 * Returns the parent structure item url if the parent is a valid structure item type
		 * @returns {string} parentStructureItem - parent structure item url
		 */
		getParentStructureItem () {
			const parentNode = this.getParent();
			if (_.contains(this.validParentStructureItemTypes, parentNode.$Type)) {
				if (parentNode.$Type == "Style") {
					// If we are in a Style, use ParentStructureItem as if it were under the collection of that style
					return parentNode.__Parent__;
				} else {
					return parentNode.$URL;
				}
			}
			return null;
		}
	});
});
